var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Fragment, useState } from 'react';
import { Button } from 'components/Button';
import { FormInput } from 'components/form/FormInput';
import { toMoney } from 'components/Money';
import { Modal } from 'components/modal/Modal';
import { Text } from 'components/Text';
import './DealCancelOrderModal.scss';
/**
 * Amounts start at zero: moving money has to be asked for, line by line.
 *
 * @component DealCancelOrderModal
 * @since 1.0.0
 * @hidden
 */
export function DealCancelOrderModal(props) {
    const { canRefund, onClose, onConfirm } = props;
    const payments = props.payments.filter((payment) => payment.status === 'COMPLETED' && payment.refundableAmount > 0);
    const [amounts, setAmounts] = useState({});
    const [reason, setReason] = useState('');
    const [processing, setProcessing] = useState(false);
    const refunds = payments
        .map((payment) => ({
        paymentId: payment.id,
        amount: Number(amounts[payment.id]) || 0,
        reason: reason.trim() || null
    }))
        .filter((refund) => refund.amount !== 0);
    const invalid = payments.some((payment) => {
        const amount = Number(amounts[payment.id]) || 0;
        return amount < 0 || amount > payment.refundableAmount;
    });
    const total = refunds.reduce((sum, refund) => sum + refund.amount, 0);
    const onPress = () => __awaiter(this, void 0, void 0, function* () {
        setProcessing(true);
        yield onConfirm(refunds);
    });
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement("div", { className: "deal-cancel-order-modal-button-container" },
            React.createElement(Button, { style: "primary", label: total > 0
                    ? t('Cancel and refund {{amount}}').replace('{{amount}}', toMoney(total))
                    : t('Cancel order'), disabled: invalid, processing: processing, onPress: onPress }))));
    return (React.createElement("div", { className: "deal-cancel-order-modal" },
        React.createElement(Modal, { picto: "file-xmark", title: t('Cancel order'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-cancel-order-modal-content" },
                React.createElement(Text, { value: t('Are you sure to cancel this order?') }),
                payments.length > 0 && !canRefund && (React.createElement(Text, { className: "deal-cancel-order-modal-notice", value: t('This order has payments. They will not be refunded: someone with access to payments can do it from the payments tab.') })),
                payments.length > 0 && canRefund && (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "deal-cancel-order-modal-notice", value: t('Enter the amount to refund for each payment, if any.') }),
                    payments.map((payment) => {
                        var _a;
                        return (React.createElement("div", { className: "deal-cancel-order-modal-payment", key: payment.id },
                            React.createElement("div", { className: "deal-cancel-order-modal-payment-infos" },
                                React.createElement(Text, { value: payment.description ||
                                        (payment.isDeposit ? t('Deposit') : t('Payment')) }),
                                React.createElement(Text, { className: "deal-cancel-order-modal-payment-max", value: t('Up to {{amount}}').replace('{{amount}}', toMoney(payment.refundableAmount)) }),
                                payment.refundProvider === 'MANUAL' && (React.createElement(Text, { className: "deal-cancel-order-modal-payment-max", value: t('To refund in Mews or outside Centralio. Only recorded here.') }))),
                            React.createElement(FormInput, { type: "number", size: "small", suffix: "$", min: "0", max: String(payment.refundableAmount), value: (_a = amounts[payment.id]) !== null && _a !== void 0 ? _a : '0', onChange: (value) => setAmounts((current) => (Object.assign(Object.assign({}, current), { [payment.id]: value }))) })));
                    }),
                    React.createElement(FormInput, { size: "small", placeholder: t('Refund reason (optional)'), value: reason, onChange: setReason }),
                    invalid && (React.createElement(Text, { className: "deal-cancel-order-modal-error", value: t('This amount exceeds what can be refunded.') }))))))));
}
